import { gql, TypedDocumentNode } from '@common/hooks';
import { DetailItemGroupedAttachments, GroupedAttachmentsType } from '..';

type ComplianceItemDrawerFilesTabQueryResponseType = {
  worksListItem: {
    id: string;
    detailItem?: {
      id: string;
      groupedAttachments: GroupedAttachmentsType;
    };
    worksList: {
      id: string;
      canUpdate: {
        value: boolean;
      };
      canApproveReject: {
        value: boolean;
      };
    };
  };
};

export const ComplianceItemDrawerFilesTabQuery: TypedDocumentNode<ComplianceItemDrawerFilesTabQueryResponseType> = gql`
  query ComplianceItemDrawerFilesTabQuery($id: ID!) {
    worksListItem(id: $id) {
      id
      detailItem {
        ... on License {
          id
          groupedAttachments {
            ...DetailItemGroupedAttachments
          }
        }
        ... on NurseAssessment {
          id
          groupedAttachments {
            ...DetailItemGroupedAttachments
          }
        }
        ... on NurseHealthDoc {
          id
          groupedAttachments {
            ...DetailItemGroupedAttachments
          }
        }
        ... on NurseCertification {
          id
          groupedAttachments {
            ...DetailItemGroupedAttachments
          }
        }
        ... on Document {
          id
          groupedAttachments {
            ...DetailItemGroupedAttachments
          }
        }
      }
    }
  }
  ${DetailItemGroupedAttachments}
`;
